import { useMemo } from 'react';
import { useSelector } from 'react-redux';

/*
Usage:
CheckUserPermission("admin")
*/

// CHECK USER PERMISSION
export function CheckUserPermission(value) {
    const { rolesData } = useSelector(state => state.auth) || {};
     const hasPermission = useMemo(() => {
        if (rolesData && Array.isArray(rolesData) && rolesData.length > 0) {
            return rolesData.some(role =>
                role.permissions && Array.isArray(role.permissions) && role.permissions.includes(value)
            );
        }
        return false;
    }, [rolesData, value]);
    
    return hasPermission;
}